import { CertificationProviderStatusEnum } from '../enums/certification-provider-status.enum';

export class CertificationProviderStatus {
    static all: { translationLabel: string; value: number }[] = [
        {
            translationLabel: 'PAGE.CERTIFICATIONS.LABEL.ACTIVE',
            value: CertificationProviderStatusEnum.Active,
        },
        {
            translationLabel: 'PAGE.CERTIFICATIONS.LABEL.ARCHIVED',
            value: CertificationProviderStatusEnum.Archived,
        },
    ];
}
